import React from 'react';
import { Breadcrumbs } from '@ok/okd';

import history from '@common/utils/history';

// Tag chips under the title; `roll` switches to the compact variant.
const HeaderTags = ({ block, tags = [], roll = false }) => (
  <div className={roll ? `${block}__tags--roll` : `${block}__tags`}>
    {tags.map((tag, idx) => (
      <span key={idx}>{tag}</span>
    ))}
  </div>
);

const DetailHeader = ({
  block,
  isRoll,
  name,
  tags,
  breadcrumb = [],
  action = null,
  rollAction = null,
}) => (
  <div className={isRoll ? `${block}__header--roll` : `${block}__header`}>
    <div className={`${block}__header-inner`}>
      {!isRoll && (
        <Breadcrumbs
          className={`${block}__breadcrumb`}
          options={breadcrumb.map((label) => ({ label }))}
          onClick={(p) => {
            if (!p.active) {
              history.push('/recruit');
            }
          }}
        />
      )}
      {!isRoll && (
        <React.Fragment>
          <div className={`${block}__title-row`}>
            <div className={`${block}__title`}>
              <div className={`${block}__title-text`}>{name}</div>
            </div>
            {action && <div className={`${block}__title-action`}>{action}</div>}
          </div>
          <HeaderTags block={block} tags={tags} />
        </React.Fragment>
      )}
      {isRoll && (
        <div className={`${block}__title-wrap`}>
          <div className={`${block}__title-row--roll`}>
            <div className={`${block}__title--roll`}>
              <div className={`${block}__title-text--roll`}>{name}</div>
            </div>
            {rollAction && (
              <div className={`${block}__title-action--roll`}>{rollAction}</div>
            )}
          </div>
          <HeaderTags block={block} tags={tags} roll />
        </div>
      )}
      <div
        className={isRoll ? `${block}__divider--roll` : `${block}__divider`}
      />
    </div>
  </div>
);

export default DetailHeader;
